import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getDepartmentId, getTenantId } from 'src/app/services/store-snapshot.service';
import { environment } from 'src/environments/environment';
import { IServiceReport } from '../models/service-report.model';
import { FormDataService } from '../../shared/attachments/service/form-data.service';

@Injectable({
  providedIn: 'root',
})
export class ServiceReportApiService {
  private readonly baseUrl = `${environment.apiUrl}/api`;

  private get url(): string {
    return `${this.baseUrl}/${getTenantId()}/${getDepartmentId()}/ServiceReports`;
  }

  constructor(private http: HttpClient) {}

  getServiceReportById(id: string): Observable<IServiceReport> {
    const url = `${this.url}/${id}`;
    return this.http.get<IServiceReport>(url);
  }

  createServiceReport(serviceReport: IServiceReport): Observable<IServiceReport> {
    const formData = FormDataService.mapToFormData(serviceReport);
    return this.http.post<IServiceReport>(this.url, formData);
  }

  updateServiceReport(serviceReport: IServiceReport): Observable<IServiceReport> {
    const formData = FormDataService.mapToFormData(serviceReport);
    return this.http.put<IServiceReport>(this.url, formData);
  }

  deleteServiceReport(id: string): Observable<void> {
    const url = `${this.url}/${id}`;
    return this.http.delete<void>(url);
  }

  printServiceReport(id: string): Observable<Blob> {
    const url = `${this.url}/${id}/Print`;
    return this.http.get(url, { responseType: 'blob' });
  }
}
